import React from 'react'

import './index.scss'

const baseClass = 'popup-divider'

export const PopupListDivider: React.FC = () => {
  return <hr className={baseClass} />
}
